export default {
      id: "nav-chevron-down-usage",
      viewBox: "0 0 8 5",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#nav-chevron-down",
      toString: function () {
        return this.url;
      }
    }